namespace $.$$ {
	
	type $shm_hitalama_textbook_toc_item = {
		readonly id: string
		readonly level: number
		readonly title: string
	}
	
	export class $shm_hitalama_textbook extends $.$shm_hitalama_textbook {

		@ $mol_mem_key
		override toc_expanded( id: string, next?: boolean ) {
			return this.Toc().expanded_state( id, next )
		}

		@ $mol_mem
		override Toc() {
			const tree = super.Toc() as $shm_tree
			tree.parent = ( id: string )=> this.toc_parent( id ) ?? undefined
			return tree
		}
		
		@ $mol_mem
		toc_items() {
			const items = [] as $shm_hitalama_textbook_toc_item[]
			
			for( const token of this.Text().flow_tokens() ) {
				if( token.name !== 'header' ) continue
				const title = token.chunks[2].trim()
				items.push({
					id: String( items.length ),
					level: token.chunks[0].length,
					title,
				})
			}
			
			return items
		}
		
		@ $mol_mem
		toc_roots() {
			return this.toc_items()
				.filter( item => !this.toc_parent( item.id ) )
				.map( item => item.id )
		}
		
		toc_item( id: string ) {
			return this.toc_items().find( item => item.id === id )!
		}
		
		toc_title( id: string ) {
			return this.toc_item( id ).title
		}
		
		toc_level( id: string ) {
			return this.toc_item( id ).level
		}
		
		@ $mol_mem
		toc_parents() {
			const parents = {} as Record< string, string | null >
			const stack = [] as $shm_hitalama_textbook_toc_item[]
			
			for( const item of this.toc_items() ) {
				while( stack.length && stack[ stack.length - 1 ].level >= item.level ) stack.pop()
				parents[ item.id ] = stack[ stack.length - 1 ]?.id ?? null
				stack.push( item )
			}
			
			return parents
		}
		
		toc_parent( id: string ) {
			return this.toc_parents()[ id ]
		}
		
		@ $mol_mem_key
		toc_child_ids( id: string ) {
			return this.toc_items()
				.filter( item => this.toc_parent( item.id ) === id )
				.map( item => item.id )
		}
		
		toc_arg( id: string ) {
			return {
				[ this.text_param() ]: this.toc_anchor( id ),
			}
		}

		toc_anchor( id: string ) {
			const item = this.toc_item( id )
			const index = this.toc_items().indexOf( item )
			const count = this.toc_items().slice( 0, index + 1 ).filter( other => other.title === item.title ).length
			return count > 1 ? `${ item.title } [${ count }]` : item.title
		}
		
		text_title() {
			return this.toc_items()[0]?.title ?? super.text_title()
		}
		
	}
	
}
